import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/v1/admin/board-certifications`;

// GET all board certifications
export async function fetchBoardCertifications() {
  const response = await axios.get(BASE_URL);
  return response.data;
}

// CREATE a new board certification
export async function createBoardCertification(data) {
  const response = await axios.post(BASE_URL, data);
  return response.data;
}

// UPDATE an existing board certification
export async function updateBoardCertification(id, data) {
  const response = await axios.put(`${BASE_URL}/${id}`, data);
  return response.data;
}

// DELETE a board certification
export async function deleteBoardCertification(id) {
  await axios.delete(`${BASE_URL}/${id}`);
}
